/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 用户状态
 */
let EnumUserStatus = {
	Normal             : new EnumItem('正常', 0),
    Stop               : new EnumItem('禁用', 1),
	...enumMixn
}
export default EnumUserStatus
